import React from 'react';
import PropTypes from 'prop-types';
import withInputValidator from './InputValidator';

class Input extends React.Component {
    render() {
        return (
            <input
                autoFocus={this.props.autoFocus}
                className={this.props.classNames}
                defaultValue={this.props.value}
                id={this.props.id}
                maxLength={this.props.maxLength}
                onChange={this.props.onChange}
                placeholder={this.props.placeholder}
                required={this.props.required}
                type={this.props.type}
            />
        );
    }
}

Input.propTypes = {
    type: PropTypes.oneOf(['text', 'email', 'password', 'url']), // add more. If you want..
    classNames: PropTypes.string,
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
    autoFocus: PropTypes.bool,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    maxLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
};

Input.defaultProps = {
    type: 'text',
    autoFocus: false,
};

export default withInputValidator(Input);
